/*
 * 点位信息管理组件
 * zxw
 * 创建时间：2025-05-20
 * 更新时间：2026-07-02
 */

import { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    Row,
    Col,
    message,
    Table,
    Input,
    Select,
    Button,
    Upload,
    Modal,
    Tag,
    Space,
    Progress,
} from 'antd';
import {
    PlusOutlined,
    ExportOutlined,
    ImportOutlined,
    LoadingOutlined,
} from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    ShowIPModal,
    isGTscreenWidth,
    winWidth,
    UdateFormat,
    rootReactDom,
    GetArrSpanMaxWidth,
    GetButtonActionName,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import Entity from './InfoEntity.js';
import PLInfo from './PLInfo.js';

const { Option } = Select;
const MODULENAME = CNF.navItems[0].submenu[1].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[1].ptn;
const MODULENAME_URL = CNF.navItems[0].submenu[1].url;

/**
 * 表格子组件
 */
const Lists = (props) => {
    const {
        btnLists,
        preGroup,
        dataLists,
        currentIndex,
        pageCount,
        qss,
        changeIndex,
        setOpen,
        refresh,
    } = props;

    const update = useCallback((record) => {
        setOpen(true, record);
    }, [setOpen]);

    /**
     * 操作选项
     */
    const operation = useCallback((action, record) => {
        const uri = MODULENAME_URL.slice(1) + '/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.name, action, MODULENAME, refresh, uri);
                break;
            default:
                break;
        }
    }, [update, refresh]);

    /**
     * 打印点位信息
     */
    const showPLInfo = useCallback((record) => {
        rootReactDom && rootReactDom.render(
            <PLInfo
                preGroup={preGroup}
                btnLists={btnLists}
                isModalOpen={true}
                record={record}
            />
        );
    }, [btnLists, preGroup]);

    const hasOpPerm = useMemo(() => (
        btnLists.includes(MODULENAME_PTN + '_visit') ||
        btnLists.includes(MODULENAME_PTN + '_update') ||
        btnLists.includes(MODULENAME_PTN + '_disable') ||
        btnLists.includes(MODULENAME_PTN + '_active') ||
        btnLists.includes(MODULENAME_PTN + '_delete')
    ), [btnLists]);

    const columns = useMemo(() => [
        { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left' },
        {
            title: '点位编号',
            key: 'number',
            fixed: 'left',
            width: 120,
            render: (record) => (
                <Button
                    color='primary'
                    variant='link'
                    style={{ padding: '0 5px', border: 0, height: 22 }}
                    onClick={() => showPLInfo(record)}
                >
                    {record.number}
                </Button>
            ),
        },
        { title: '所属辖区', dataIndex: 'police_station', key: 'police_station', fixed: 'left', width: 120 },
        { title: '点位名称', dataIndex: 'name', key: 'name', fixed: 'left', width: GetArrSpanMaxWidth(dataLists, 'name', 100) },
        { title: '点位详细地址', dataIndex: 'address', key: 'address', width: GetArrSpanMaxWidth(dataLists, 'address', 120) },
        { title: '一杆几机', dataIndex: 'rod_device_count', key: 'rod_device_count', width: 100 },
        {
            title: '球机',
            dataIndex: 'high_ball',
            key: 'high_ball',
            width: 100,
            hidden: qss && qss.high_ball > 0 ? false : true,
        },
        {
            title: '双舱',
            dataIndex: 'double_cabins',
            key: 'double_cabins',
            width: 100,
            hidden: qss && qss.double_cabins > 0 ? false : true,
        },
        {
            title: '双拼',
            dataIndex: 'double_pinyin',
            key: 'double_pinyin',
            width: 100,
            hidden: qss && qss.double_pinyin > 0 ? false : true,
        },
        {
            title: '大卡',
            dataIndex: 'vehicle_checkpoint',
            key: 'vehicle_checkpoint',
            width: 100,
            hidden: qss && qss.vehicle_checkpoint > 0 ? false : true,
        },
        {
            title: '利旧',
            dataIndex: 'old_equipment',
            key: 'old_equipment',
            width: 100,
            hidden: qss && qss.old_equipment > 0 ? false : true,
        },
        { title: '抱杆箱', dataIndex: 'intelligent_box', key: 'intelligent_box', width: 100 },
        { title: '安装方式', dataIndex: 'installation_method', key: 'installation_method', width: 100 },
        {
            title: '杆型',
            key: 'rod_type',
            width: 100,
            render: (record) => record.rod_type || '-',
        },
        {
            title: '建议高度',
            key: 'installation_height',
            width: 100,
            render: (record) => record.installation_height || '-',
        },
        {
            title: '杆高',
            key: 'rod_height',
            width: 100,
            render: (record) => {
                if (record.installation_method === CNF.installationMethod[0].value && record.rod_height > 0) {
                    return record.rod_height + 'm';
                } else if (record.rod_height > 0) {
                    return '≥' + record.rod_height + 'm';
                } else {
                    return '-';
                }
            },
        },
        {
            title: '臂长',
            key: 'arm_length',
            width: 130,
            render: (record) => record.arm_length || '-',
        },
        {
            title: '臂朝向',
            key: 'arm_orientation',
            width: GetArrSpanMaxWidth(dataLists, 'arm_orientation', 100),
            render: (record) => record.arm_orientation || '-',
        },
        { title: '防控区域', dataIndex: 'control_area', key: 'control_area', width: GetArrSpanMaxWidth(dataLists, 'control_area', 100) },
        {
            title: '泥土路面',
            key: 'dirt_road',
            width: 100,
            render: (record) => (record.dirt_road > 0 ? record.dirt_road + 'm' : '0.0'),
        },
        {
            title: '水泥路面',
            key: 'cement_road',
            width: 100,
            render: (record) => (record.cement_road > 0 ? record.cement_road + 'm' : '0.0'),
        },
        {
            title: '沥青路面',
            key: 'asphalt_road',
            width: 100,
            render: (record) => (record.asphalt_road > 0 ? record.asphalt_road + 'm' : '0.0'),
        },
        {
            title: '人行道',
            key: 'sidewalk',
            width: 100,
            render: (record) => (record.sidewalk > 0 ? record.sidewalk + 'm' : '0.0'),
        },
        { title: '接电方式', dataIndex: 'connect_electricity_method', key: 'connect_electricity_method', width: 120 },
        {
            title: '电源长度',
            key: 'power_supply_length',
            width: 100,
            render: (record) => (record.power_supply_length > 0 ? record.power_supply_length + 'm' : '0.0'),
        },
        { title: '接电位置', dataIndex: 'connect_electricity_location', key: 'connect_electricity_location', width: GetArrSpanMaxWidth(dataLists, 'connect_electricity_location', 120) },
        { title: '经纬度', dataIndex: 'longitude_latitude', key: 'longitude_latitude', width: 250 },
        { title: '所属点位采集', dataIndex: 'collect_name', key: 'collect_name', width: 400 },
        { title: '采集日期', dataIndex: 'collection_date', key: 'collection_date', width: 100 },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth },
        { title: '状态', key: 'status', dataIndex: 'status', width: CNF.tableStatusColumnWidth - 20 },
        {
            title: '',
            key: 'operation',
            fixed: 'right',
            width: 168,
            hidden: !hasOpPerm,
            render: (record) => GetButtonActionName(btnLists, MODULENAME_PTN, record, operation),
        },
    ], [btnLists, dataLists, qss, hasOpPerm, operation, showPLInfo]);

    return (
        <Table
            columns={columns}
            size='middle'
            dataSource={dataLists}
            scroll={{ x: winWidth }}
            pagination={{
                showSizeChanger: false,
                showQuickJumper: false,
                showTotal: () => (
                    <Space size='small'>
                        总计:<Tag color={CNF.swatches[CNF.currentSwatche][0]}>{qss?.rod_device_count || 0}个</Tag>
                        {qss?.high_ball > 0 && (
                            <>球机:<Tag color={CNF.swatches[CNF.currentSwatche][1]}>{qss.high_ball}个</Tag></>
                        )}
                        {qss?.double_cabins > 0 && (
                            <>双舱:<Tag color={CNF.swatches[CNF.currentSwatche][2]}>{qss.double_cabins}个</Tag></>
                        )}
                        {qss?.double_pinyin > 0 && (
                            <>双拼:<Tag color={CNF.swatches[CNF.currentSwatche][3]}>{qss.double_pinyin}个</Tag></>
                        )}
                        {qss?.vehicle_checkpoint > 0 && (
                            <>大卡:<Tag color={CNF.swatches[CNF.currentSwatche][4]}>{qss.vehicle_checkpoint}个</Tag></>
                        )}
                        {qss?.old_equipment > 0 && (
                            <>利旧:<Tag color={CNF.swatches[CNF.currentSwatche][5]}>{qss.old_equipment}个</Tag></>
                        )}
                        共{pageCount > 10000 ? (pageCount / 10000).toFixed(CNF.DPL) + '万' : pageCount}条
                    </Space>
                ),
                pageSize: CNF.pageSize,
                current: currentIndex,
                total: pageCount,
                onShowSizeChange: (current, pageSize) => props?.changePageSize?.(pageSize, current),
                onChange: (current) => changeIndex(current),
            }}
        />
    );
};

/**
 * 主组件
 */
const Info = (props) => {
    const { btnLists, preGroup } = props;

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [modal, modalContextHolder] = Modal.useModal();

    // 状态管理
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const [qss, setQss] = useState(null);
    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);

    // 搜索条件
    const [collectUlid, setCollectUlid] = useState('');
    const [number, setNumber] = useState('');
    const [name, setName] = useState('');
    const [policeStation, setPoliceStation] = useState('');
    const [status, setStatus] = useState(CNF.status[0].value);

    // 下拉列表数据
    const [collectLists, setCollectLists] = useState([]);

    // 刷新函数
    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    const handleStatusChange = useCallback((value) => {
        setStatus(value || '');
        setCurrentIndex(1);
    }, []);

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleCollectChange = useCallback((value) => {
        setCollectUlid(value || '');
        setCurrentIndex(1);
    }, []);

    const handleNumberChange = useCallback((e) => {
        setNumber(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handleNameChange = useCallback((e) => {
        setName(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handlePoliceStationChange = useCallback((e) => {
        setPoliceStation(e.target.value);
        setCurrentIndex(1);
    }, []);

    // 打开模态框
    const setOpenModal = useCallback((value, recordData = null) => {
        setOpen(value);
        setRecord(recordData);
    }, []);

    // 创建
    const create = useCallback(() => {
        setOpenModal(true, null);
    }, [setOpenModal]);

    // 获取采集点下拉列表（仅加载一次）
    useEffect(() => {
        const params = {
            rss: 'list',
            page_size: CNF.maxPageSize,
            current_index: 1,
        };
        $.ajax({
            url: `${CNF.api}pointLocations/collects${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
            success: (data) => {
                if (data.res === 0) {
                    setCollectLists(data.dat || []);
                }
            },
        });
    }, []);

    // 获取列表数据
    useEffect(() => {
        setLoading(true);

        const params = {
            collect_ulid: collectUlid,
            number,
            name,
            status,
            police_station: policeStation,
            page_size: CNF.pageSize,
            current_index: currentIndex,
        };
        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
            success: (data) => {
                if (data.res === 0) {
                    setDataLists(data.dat || []);
                    setPageCount(data.cnt || 0);
                    setQss(data.qss || null);
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            },
            error: (err) => {
                messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
            },
            complete: () => {
                setLoading(false);
            },
        });
    }, [collectUlid, number, name, policeStation, status, currentIndex, triggerRefresh, messageApi]);

    // ---------- 导入导出相关 ----------
    const [instance, setInstance] = useState(null);

    const uploadCheck = useCallback((info) => {
        if (info.size > 10240000) {
            messageApi.error('上传文件超过10M，建议拆分文件！', CNF.messageDuration);
            return false;
        }
        if (!info.name.match(/.xls[x]{0,1}/)) {
            messageApi.error('文件格式不对，只支持 xls 或 xlsx ！', CNF.messageDuration);
            return false;
        }
        setInstance(
            modal.info({
                width: isGTscreenWidth ? 500 : 600,
                title: <Space>文件正在上传<LoadingOutlined /></Space>,
                content: <Progress percent={0} />,
                footer: null,
                icon: null,
                keyboard: false,
                closable: false,
            })
        );
        return true;
    }, [messageApi, modal]);

    /**
     * 更新导入弹框
     * @param {*} modal 
     * @param {*} title 
     * @param {*} data 
     * @param {*} percent 
     * @param {*} status 
     */
    const updateModal = useCallback((modalInstance, title, data, percent, status) => {
        modalInstance.update((prevConfig) => ({
            ...prevConfig,
            title,
            content: (
                <>
                    <Progress percent={percent} style={{ width: '100%' }} />
                    <Row style={{ marginTop: CNF.rowMarginTop }}>
                        <Col span={4}><strong>表格序号</strong></Col>
                        <Col span={12}><strong>点位编号</strong></Col>
                        <Col span={8}><strong>操作说明</strong></Col>
                    </Row>
                    <div
                        id='import-modal-id'
                        style={{
                            height: 360,
                            marginTop: CNF.rowMarginTop,
                            overflowY: 'auto',
                        }}
                    >
                        {data.map((item, index) => (
                            <Row style={{ lineHeight: 2 }} key={index}>
                                <Col span={4}>{item.key}</Col>
                                <Col span={12}>{item.number}</Col>
                                <Col span={8} style={{ color: item.msg.includes('成功') ? '#000' : item.msg.includes('已导入') ? 'green' : 'red' }}>
                                    {item.msg}
                                </Col>
                            </Row>
                        ))}
                    </div>
                    {status === 'done' && (
                        <div style={{ marginTop: CNF.rowMarginTop * 2, width: '100%', textAlign: 'right' }}>
                            <Button
                                title='确定'
                                variant='solid'
                                style={{ background: global.THEMECOLOR, color: '#fff', border: 0 }}
                                onClick={() => {
                                    modalInstance.destroy();
                                    refresh();
                                }}
                            >
                                确定
                            </Button>
                        </div>
                    )}
                </>
            ),
        }));
    }, [refresh]);

    const getJob = useCallback(
        async (modalInstance, jobId) => {
            instance?.update((prevConfig) => ({
                ...prevConfig,
                title: <Space>点位正在导入<LoadingOutlined /></Space>,
                content: <Progress percent={0} />,
            }));
            const messageData = [];
            let total = 0;          // 总记录数（首次获取后固定）
            let processed = 0;      // 已处理记录数（累加）

            try {
                const response = await fetch(CNF.api + 'pointLocations/infoLists?job_id=' + jobId, {
                    method: 'GET',
                    headers: AddRequestHeaders(),
                    openWhenHidden: true,
                });
                if (!response.ok) {
                    // 处理错误
                }
                const reader = response.body.getReader();
                const td = new TextDecoder('utf-8');
                let jsonData = null;
                while (true) {
                    const { done, value } = await reader.read();
                    const text = td.decode(value, { stream: true });
                    const jsonMatch = text.match(/data:\s*({.*?})\s*\n/);

                    // 计算进度（避免除零）
                    const percent = total > 0 ? (processed / total) * 100 : 0;
                    const percentFixed = parseFloat(percent.toFixed(CNF.DPL));

                    if (jsonMatch) {
                        jsonData = JSON.parse(jsonMatch[1]);
                    } else {
                        if (done) {
                            // 更新进度
                            updateModal(
                                modalInstance,
                                '点位导入结束！',
                                messageData,
                                percentFixed,
                                'done'
                            );
                            break
                        };
                        continue;
                    }

                    // 若服务端返回错误，直接终止
                    if (jsonData.res !== 0) {
                        modalInstance.destroy();
                        messageApi.error(jsonData.msg, CNF.messageDuration);
                        break;
                    }

                    // 首次获取 total，之后固定
                    if (total === 0 && jsonData.total) {
                        total = jsonData.total;
                    }

                    // 累加本批次记录数
                    const batchData = jsonData.data || [];
                    if (batchData.length) {
                        messageData.push(...batchData);
                        processed += batchData.length;
                    }

                    // 判断是否完成（服务端标识完成 或 已处理数达到总数）
                    const isFinished = jsonData?.id === jsonData?.total || processed >= total;

                    if (done || isFinished) {
                        // 完成时强制 100%
                        updateModal(
                            modalInstance,
                            isFinished ? '点位导入完成！' : '点位导入结束！',
                            messageData,
                            100
                        );
                        break;
                    } else {
                        // 更新进度
                        updateModal(
                            modalInstance,
                            <Space>点位正在导入<LoadingOutlined /></Space>,
                            messageData,
                            percentFixed
                        );
                    }

                    // 滚动至底部
                    const div = document.getElementById('import-modal-id');
                    if (div) {
                        div.scrollTop = div.scrollHeight;
                        div.style.scrollBehavior = 'smooth';
                        div.scrollTo(0, div.scrollHeight);
                    }
                }
            } catch (e) {
                instance?.update((prevConfig) => ({
                    ...prevConfig,
                    closable: true,
                    onCancel: () => refresh(),
                }));
                messageApi.error('网络错误 !', CNF.messageDuration);
            }
        },
        [instance, messageApi, updateModal, refresh]
    );

    const upload = useCallback(
        (info) => {
            if (info.file.status === 'uploading') {
                instance?.update((prevConfig) => ({
                    ...prevConfig,
                    content: <Progress percent={parseFloat(info.file.percent).toFixed(CNF.DPL)} />,
                }));
            } else if (info.file.status === 'done') {
                instance?.update((prevConfig) => ({
                    ...prevConfig,
                    title: '文件上传完成！',
                    content: <Progress percent={100} />,
                }));
                if (info.file.response?.dat) {
                    setTimeout(() => {
                        getJob(instance, info.file.response.dat.job_id);
                    }, 1000);
                } else {
                    instance?.destroy();
                    messageApi.error(info.file.response?.msg || '上传失败', CNF.messageDuration);
                }
            } else if (info.file.status === 'error') {
                instance?.destroy();
                messageApi.error(`${info.file.name} 导入失败！`, CNF.messageDuration);
            }
        },
        [instance, getJob, messageApi]
    );

    // 导出
    const exportAsExcel = useCallback((data) => {
        const date = new Date();
        const option = {
            fileName: '点位信息明细-' + UdateFormat('YYYY-mm-dd', date),
            datas: [
                {
                    sheetData: data,
                    sheetName: '点位信息明细',
                    sheetHeader: [
                        '点位编号',
                        '派出所',
                        '点位名称',
                        '点位详细地址',
                        '一杆几机',
                        '球机',
                        '双舱',
                        '双拼',
                        '大卡',
                        '利旧',
                        '智能箱',
                        '安装方式',
                        '杆型',
                        '建议高度',
                        '杆高',
                        '臂长',
                        '臂朝向',
                        '防控区域',
                        '泥土路面',
                        '水泥路面',
                        '沥青路面',
                        '人行道',
                        '接电方式',
                        '电源长度',
                        '接电位置',
                        '经纬度',
                        '采集日期',
                        '备注',
                    ],
                },
            ],
        };
        const toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
    }, []);

    const exportAsLists = useCallback(() => {
        const params = {
            collect_ulid: collectUlid,
            number,
            name,
            police_station: policeStation,
            status,
            page_size: CNF.maxPageSize,
            current_index: 1,
        };
        $.ajax({
            url: `${CNF.api}pointLocations/infos${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
            success: (data) => {
                if (data.res === 0) {
                    const d = (data.dat || []).map((item) => {
                        const newItem = { ...item };
                        // 删除不必要的字段
                        delete newItem.key;
                        delete newItem.create_username;
                        delete newItem.create_displayname;
                        delete newItem.create_time;
                        delete newItem.update_time;
                        delete newItem.status;
                        delete newItem.collect_ulid;
                        delete newItem.collect_number;
                        delete newItem.collect_name;
                        delete newItem.installation_location_image_path;
                        delete newItem.connect_electricity_location_image_path;
                        // 添加单位
                        ['rod_height', 'dirt_road', 'cement_road', 'asphalt_road', 'sidewalk', 'power_supply_length'].forEach((field) => {
                            if (newItem[field] > 0) {
                                newItem[field] = newItem[field].toString() + 'm';
                            }
                        });
                        return newItem;
                    });
                    exportAsExcel(d);
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            },
            error: (err) => {
                messageApi.error(err.responseJSON?.detail || '导出失败', CNF.messageDuration);
            },
        });
    }, [collectUlid, number, name, policeStation, status, exportAsExcel, messageApi]);

    // 按钮权限判断
    const hasCreate = btnLists.includes(MODULENAME_PTN + '_create');
    const hasImport = btnLists.includes(MODULENAME_PTN + '_import');
    const hasExport = btnLists.includes(MODULENAME_PTN + '_export');

    return (
        <>
            {contextHolder}
            {modalContextHolder}
            {/* 搜索栏 */}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Select
                    showSearch
                    allowClear
                    placeholder='所属点位采集'
                    style={{ width: isGTscreenWidth ? 300 : 350 }}
                    onChange={handleCollectChange}
                    filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    value={collectUlid || undefined}
                >
                    {collectLists.map((item) => (
                        <Option key={item.key} value={item.key}>
                            {item.name}
                        </Option>
                    ))}
                </Select>
                <Input
                    onChange={handleNumberChange}
                    placeholder='点位编码'
                    value={number}
                />
                <Input
                    onChange={handleNameChange}
                    placeholder='点位名称'
                    value={name}
                />
                <Input
                    onChange={handlePoliceStationChange}
                    placeholder='所属辖区'
                    value={policeStation}
                />
                <Select
                    allowClear
                    placeholder='状态'
                    style={{ width: '100%' }}
                    onChange={handleStatusChange}
                    options={CNF.status.map((item) => ({
                        key: item.value,
                        value: item.value,
                        label: item.key,
                    }))}
                    value={status || undefined}
                />
                {hasCreate && (
                    <Button
                        title={CNF.actionName.CREATE + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<PlusOutlined />}
                        onClick={create}
                    >
                        {CNF.actionName.CREATE}
                    </Button>
                )}
                {hasImport && (
                    <Upload
                        action={CNF.api + 'pointLocations/infoLists'}
                        headers={AddRequestHeaders(false)}
                        onChange={upload}
                        beforeUpload={uploadCheck}
                        showUploadList={false}
                        name='file'
                        accept='xlsx,xls'
                    >
                        <Button
                            title={CNF.actionName.IMPORT + MODULENAME}
                            color='primary'
                            variant='solid'
                            icon={<ImportOutlined />}
                        >
                            {CNF.actionName.IMPORT}
                        </Button>
                    </Upload>
                )}
                {hasExport && (
                    <Button
                        title={CNF.actionName.EXPORT + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<ExportOutlined />}
                        onClick={exportAsLists}
                    >
                        {CNF.actionName.EXPORT}
                    </Button>
                )}
            </Space>
            <Lists
                btnLists={btnLists}
                preGroup={preGroup}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                qss={qss}
                changeIndex={changeIndex}
                setOpen={setOpenModal}
                refresh={refresh}
                loading={loading}
            />
            <Entity
                preGroup={preGroup}
                btnLists={btnLists}
                open={open}
                record={record}
                collectLists={collectLists}
                setOpen={setOpenModal}
                refresh={refresh}
            />
        </>
    );
};

export default Info;